export default {
  methods: {
    setFullUser (resp) {
      if (!resp) return {}
      const user = resp.getBasicProfile()
      if (!user) return {}
      const userFull = {
        id: user.getId(),
        name: user.getName(),
        firstname: user.getGivenName(),
        lastname: user.getFamilyName(),
        image: user.getImageUrl(),
        email: user.getEmail()
      }
      return userFull
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/setUserInfo.js